import React, { useState, useEffect } from 'react';

import FileBase from "react-file-base64"
import { Benefit } from './index'
import { useDispatch } from 'react-redux';
import { createBenefits, getBenefits } from '../actions/benefits';
import { useSelector } from 'react-redux';

type PropsFormBenefit = {
    // ?: number;
    // set?: any;
};

const FormBenefit: React.FC<PropsFormBenefit> = () => {

    const [benefitData, setBenefitData] = useState({ title: '', description: '', image: '' });
    
    const benefits = useSelector((state: any) => state.benefits)

    const dispatch = useDispatch();

    const handleSubmitBenefit = (e: any) => {
        e.preventDefault();
        
        dispatch(createBenefits(benefitData));
        
        clearBenefit();
    }
    
    const clearBenefit = () => {
        setBenefitData({ title: '', description: '', image: ''});
    }

    useEffect(() => {
        dispatch(getBenefits())
    }, [dispatch])
    

    return (
        <form className="_shadow-xl _bg-white _rounded-card _p-md _w-auto" onSubmit={handleSubmitBenefit}>
            <h1 className="_text-center"> Créer un Benefice </h1>
            <div className="_flex _flex-col">
                <input
                    className="_p-xs _rounded-md _my-sm _bg-gray"
                    type="text"
                    name="title"
                    value={benefitData.title}
                    placeholder="Nom du benefice"
                    onChange={(e) => setBenefitData({ ...benefitData, title: e.target.value })}
                />
                <textarea
                    className="_p-xs _rounded-md _bg-gray _mb-sm"
                    style={{ height: '200px' }}
                    name="description"
                    value={benefitData.description}
                    placeholder="description du benefice"
                    onChange={(e) => setBenefitData({ ...benefitData, description: e.target.value })}
                />
                <h2 className="_mb-sm"> Choisissez une image : </h2>
                <FileBase
                    type="file"
                    name="images"
                    multiple={false}
                    className="_p-xs _rounded-md _mb-sm _bg-gray"
                    onDone={({base64}) => setBenefitData({ ...benefitData, image: base64})}
                />
            </div>
            <section className="_flex _flex-col">
                <h1 className="_my-sm"> Liste des benefices </h1>
                <div className="_flex _flex-wrap">
                    {benefits.map((benefit, i) => {
                        return <Benefit isForm={true} key={benefit._id} benefit={benefit} />
                    })}
                </div>
            </section>
            <div className="_flex _justify-end _mt-sm">
                <button type="reset" onClick={clearBenefit}>Annuler </button>
                <button type="submit" className="_ml-sm _bg-green _rounded-md hover:_bg-darkengreen _text-white _font-bold _py-xs _px-sm _rounded-lg">
                    Créer
                </button>
            </div>
        </form>
    );
    
};

export default FormBenefit;



